import * as React from 'react';
export const SvgTechnicalPreviewBadge = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', ...props },
        React.createElement("linearGradient", { id: 'technical-preview-badge_svg__a', gradientUnits: 'userSpaceOnUse', x1: 8, x2: 8, y1: 15, y2: 1 },
            React.createElement("stop", { offset: 0, stopColor: '#ffc335' }),
            React.createElement("stop", { offset: 1, stopColor: '#ffdf52' })),
        React.createElement("path", { d: 'M15 1v14L1 1z', fill: 'url(#technical-preview-badge_svg__a)' }),
        React.createElement("path", { d: 'M15 1v14L1 1zm0-1H1a.875.875 0 00-.9.6.913.913 0 00.2 1.1l14 14a.908.908 0 00.7.3.601.601 0 00.4-.1.961.961 0 00.6-.9V1a.945.945 0 00-1-1z', fill: '#ffc000' }),
        React.createElement("circle", { cx: 11, cy: 5, opacity: 0.9, r: 2 })));
};
export default SvgTechnicalPreviewBadge;
